import path from 'path';

const INVALID_FILENAME_CHARACTER_REGEXP = /[\\/:*?"<>|]/;

export interface InvalidFilenameInfo {
  path: string;
  reason: 'IllegalFileName';
  isDir: boolean;
}

export type InvalidFilenameChange =
  | { type: 'snapshot'; files: InvalidFilenameInfo[] }
  | { type: 'add'; files: InvalidFilenameInfo[] }
  | { type: 'remove'; paths: string[] };

export function validateFileName(fileName: string): boolean {
  return !INVALID_FILENAME_CHARACTER_REGEXP.test(fileName);
}

/**
 * 找到 rootPath 下第一个包含非法字符的路径节点。
 * 当事件来自非法目录的后代时，返回该非法目录，避免逐个上报整棵子树。
 */
export function getInvalidFilenameInfo(
  rootPath: string,
  filePath: string,
  currentPathIsDir: boolean,
): InvalidFilenameInfo | null {
  const relativePath = path.relative(rootPath, filePath);
  if (
    !relativePath ||
    relativePath === '..' ||
    relativePath.startsWith(`..${path.sep}`) ||
    path.isAbsolute(relativePath)
  ) {
    return null;
  }

  const segments = relativePath.split(path.sep).filter(Boolean);
  const invalidIndex = segments.findIndex(segment => !validateFileName(segment));
  if (invalidIndex === -1) return null;

  return {
    path: path.join(rootPath, ...segments.slice(0, invalidIndex + 1)),
    reason: 'IllegalFileName',
    isDir: invalidIndex < segments.length - 1 || currentPathIsDir,
  };
}
